
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AngleLeftRightIcon',
  props: {
    right: {
      type: Boolean,
      required: true
    }
  }
})
